<template>
  <div class="padding-10">
    <v-card :elevation="$root.ele">
      <v-tabs v-model="tab">
        <v-tabs-slider></v-tabs-slider>
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <Global></Global>
      </v-tab-item>
      <v-tab-item> <Service></Service> </v-tab-item>
      <v-tab-item> <order></order> </v-tab-item>
      <v-tab-item>
        <fields-conditions />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import FieldsConditions from "../components/fields/FieldsConditions.vue";
import Global from "../components/fields/Global.vue";
import Order from "../components/fields/Order.vue";
import Service from "../components/fields/Service.vue";
export default {
  components: {
    Global,
    Service,
    Order,
    FieldsConditions,
  },
  data() {
    return {
      tab: 0,
      items: [
        "Global Fields",
        "Service Fields",
        // "Calculated Fields",
        "Field Order",
        "Conditions",
      ],
    };
  },
  mounted() {},
};
</script>

<style></style>
